import ZesstaLogo from 'assets/images/ZesstaLogo.svg';
import { useAuthStore } from 'features/auth/stores/authStore';
import React from 'react';
import { WORKSPACE_NAME } from 'shared/constants/workspaceConstants';

import {
  TopBarAvatar,
  TopBarLogo,
  TopBarLogoWrapper,
  TopBarRoot,
  TopBarSpacer,
  TopBarToolbar,
  TopBarWorkspaceName,
} from './TopBar.styles';

export const TopBar: React.FC = () => {
  const { user } = useAuthStore();

  const initials = user?.name
    ? user.name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    : 'U';

  return (
    <TopBarRoot position="static" color="inherit" elevation={0}>
      <TopBarToolbar>
        <TopBarLogoWrapper>
          <TopBarLogo src={ZesstaLogo} alt="Zessta" />
        </TopBarLogoWrapper>
        <TopBarWorkspaceName variant="body2" color="text.secondary">
          {WORKSPACE_NAME}
        </TopBarWorkspaceName>

        <TopBarSpacer />

        <TopBarAvatar src={user?.avatarUrl ?? undefined} alt={user?.name ?? 'User'}>
          {initials}
        </TopBarAvatar>
      </TopBarToolbar>
    </TopBarRoot>
  );
};
